// extracted by mini-css-extract-plugin
module.exports = {"cardDetail__detailsItem":"cardDetail__detailsItem","detailsItem__text":"detailsItem__text"};